import React, { useEffect, useState } from 'react'
import { db } from '../../../../../firebase';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Link } from 'react-router-dom';


function Post({ amount, branchId,mealId,menuId, name, price, received, restId, image }) {
    const [branch, setBranch] = useState()
    useEffect(() => {
        db.collection('branches').doc(`${branchId}`).onSnapshot((doc) => {
            setBranch(doc.data());
        });
    }, [])

  return (
    <div className="bg-white card mb-4 order-list shadow-sm">
                    <div className="gold-members p-4">
                      <div className="media">
                          <div className="media-body"><a href="#">
                            <span className="float-right text-info">
                            <img className="mr-4" src={image} alt="Generic placeholder image" />
                                </span>
                          </a><h6 className="mb-2"><a href="#">
                            </a><a href="detail.html" className="text-black">{branch?.branch}
                            </a></h6>
                          <p className="text-gray mb-1"><i className="icofont-location-arrow" />{branch?.branchAddress}
                          </p>
                          <p className="text-gray mb-3"><EmailIcon className="icofont-list" /> {branch?.branchEmail} <LocalPhoneIcon className="icofont-clock-time ml-2" />{branch?.branchPhone}</p>
                          {/* <p className="text-gray mb-3"><i className="icofont-list" /> ORDER #25102589748 <i className="icofont-clock-time ml-2" /> Mon, Nov 12, 6:26 PM</p> */}
                          <p className="text-dark">@ P {parseFloat(price).toFixed(2)} || {name} x {amount}
                          </p>
                          <hr />
                          <div className="float-right">
                            <Link className="btn btn-sm btn-primary" to={`/branchdetails/${branchId}`}><i className="icofont-refresh" /> VISIT RESTAURANT</Link>
                          </div>
                          <p className="mb-0 text-black text-primary pt-2"><span className="text-black font-weight-bold"> Total: </span>P {parseFloat(amount * price).toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div> 
  )
}

export default Post